import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StoreNameService {
  private readonly storeName$: ReplaySubject<string>;

  constructor() {
    this.storeName$ = new ReplaySubject<string>(1);
    this.storeName$.next('');
  }

  setStoreName(menu: string): void {
    this.storeName$.next(menu);
  }

  getStoreName$(): ReplaySubject<string> {
    return this.storeName$;
  }
}
